export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibres x Pallet"])},
          "sizes_by_pallet_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generar packing list"])},
          "package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallet"])},
          "crop_size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibre"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop sizes x Pallet"])},
          "sizes_by_pallet_report_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Generate packing list"])},
          "package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pallet"])},
          "crop_size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crop size"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])}
        }
      }
    }
  })
}